module.exports = __webpack_public_path__ + "static/img/Two of Pentacles.96e8a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Two of Pentacles.jpg
// module id = 1330
// module chunks = 0